
import React, { useEffect, useState } from 'react';
import './Cateringcoustmize.css';

const CateringCustomize = () => {
    const authToken = localStorage.getItem('authToken');
    const userId = localStorage.getItem("userId");
    const vendorId = localStorage.getItem("vendorId");

    const [form, setForm] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
        eventDate: '',
        eventType: '',
        guestCount: '',
        vegPlates: '',
        nonVegPlates: '',
        budget: '',
        specialRequests: '',
        fullAddress: '',
        city: '',
        state: '',
        pincode: ''
    });

    const [allDishes, setAllDishes] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedDishes, setSelectedDishes] = useState([]);
    const [filter, setFilter] = useState("ALL");
    const [openDropdowns, setOpenDropdowns] = useState({}); // For dropdown accordion

    const [addOns, setAddOns] = useState([
        { type: "SERVICE_BOYS", selected: false, quantity: 0 },
        { type: "WATER_BOTTLES", selected: false, quantity: 0 },
        { type: "PAPER_PLATES", selected: false, quantity: 0 }
    ]);

    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingDishes, setLoadingDishes] = useState(true);

    // Fetch dishes
    useEffect(() => {
        const fetchDishes = async () => {
            setLoadingDishes(true);
            setMessage(null);

            try {
                const response = await fetch(
                    `https://backend.maamaas.com/catering/api/user/dishes/getAll`,
                    {
                        headers: {
                            "Authorization": `Bearer ${authToken}`,
                        },
                    }
                );

                const data = await response.json();

                if (Array.isArray(data)) {
                    const categoryList = data.filter(d => d.parentId === null);
                    setCategories(categoryList);
                    setAllDishes(data);
                    
                    // Initialize all dropdowns as closed
                    const initialDropdownState = {};
                    categoryList.forEach(cat => {
                        initialDropdownState[cat.dishId] = false;
                    });
                    setOpenDropdowns(initialDropdownState);
                }
            } catch (error) {
                setMessage({ type: "error", text: "Failed to load dishes ❌" });
            } finally {
                setLoadingDishes(false);
            }
        };

        if (authToken) fetchDishes();
    }, [authToken]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const formatDate = (date) => {
        if (!date) return '';
        const [y, m, d] = date.split('-');
        return `${d}-${m}-${y}`;
    };

    // Toggle category dropdown (accordion)
    const toggleCategoryDropdown = (categoryId) => {
        setOpenDropdowns(prev => ({
            ...prev,
            [categoryId]: !prev[categoryId]
        }));
    };

    const toggleDish = (dishId) => {
        setSelectedDishes(prev =>
            prev.includes(dishId)
                ? prev.filter(id => id !== dishId)
                : [...prev, dishId]
        );
    };

    const handleAddonChange = (index, field, value) => {
        const updated = [...addOns];
        updated[index][field] = field === "quantity" ? Number(value) : value;
        setAddOns(updated);
    };

    // Get dishes for a specific category
    const getDishesByCategory = (categoryId) => {
        return allDishes.filter(dish => dish.parentId === categoryId);
    };

    // Filter dishes by veg/non-veg
    const filterDishesByType = (dishes) => {
        if (filter === "ALL") return dishes;
        if (filter === "VEG") return dishes.filter(d => d.dishType?.toUpperCase() === "VEG");
        if (filter === "NON-VEG") return dishes.filter(d => d.dishType?.toUpperCase() === "NON-VEG");
        return dishes;
    };

    // Get selected dishes details
    const getSelectedDishesDetails = () => {
        return allDishes.filter(dish => selectedDishes.includes(dish.dishId));
    };

    const removeSelectedDish = (dishId) => {
        setSelectedDishes(prev => prev.filter(id => id !== dishId));
    };

    const clearAllSelectedDishes = () => {
        setSelectedDishes([]);
    };

    // Handle submit
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setLoading(true);
    //     setMessage(null);

    //     if (selectedDishes.length === 0) {
    //         setMessage({ type: "error", text: "Select at least 1 dish ❌" });
    //         setLoading(false);
    //         return;
    //     }

    //     const payload = {
    //         userId: Number(userId),
    //         vendorId: Number(vendorId),
    //         customerId: `CUST_${Date.now()}`,
    //         fullName: form.fullName,
    //         email: form.email,
    //         phoneNumber: form.phoneNumber.replace(/^0+/, ''),
    //         event: "EVENT",
    //         eventType: form.eventType || "OTHER",
    //         eventDate: formatDate(form.eventDate),
    //         fromDate: formatDate(form.eventDate),
    //         toDate: formatDate(form.eventDate),
    //         eventTime: "18:30",
    //         fullAddress: form.fullAddress,
    //         city: form.city,
    //         state: form.state,
    //         country: "India",
    //         pincode: Number(form.pincode) || 0,
    //         vegPlates: Number(form.vegPlates) || 0,
    //         nonVegPlates: Number(form.nonVegPlates) || 0,
    //         budget: Number(form.budget) || 0,
    //         paymentAmount: 0,
    //         additionalRequests: form.specialRequests || '',
    //         leadStatus: "PENDING",
    //         dishId: selectedDishes,
    //         addOns: addOns
    //             .filter(a => a.selected && a.quantity > 0)
    //             .map(a => ({
    //                 addOnType: a.type,
    //                 quantity: a.quantity
    //             }))
    //     };

    //     try {
    //         const res = await fetch(
    //             `https://backend.maamaas.com/catering/api/user/enquiry/create/`,
    //             {
    //                 method: "POST",
    //                 headers: {
    //                     "Authorization": `Bearer ${authToken}`,
    //                     "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify(payload)
    //             }
    //         );

    //         if (res.ok) {
    //             alert("Submitted Successfully ✅");
    //             setSelectedDishes([]);
    //             setForm({
    //                 fullName: '',
    //                 email: '',
    //                 phoneNumber: '',
    //                 eventDate: '',
    //                 eventType: '',
    //                 guestCount: '',
    //                 vegPlates: '',
    //                 nonVegPlates: '',
    //                 budget: '',
    //                 specialRequests: '',
    //                 fullAddress: '',
    //                 city: '',
    //                 state: '',
    //                 pincode: ''
    //             });
    //         } else {
    //             setMessage({ type: "error", text: "Submission failed ❌" });
    //         }
    //     } catch {
    //         setMessage({ type: "error", text: "Network error ❌" });
    //     } finally {
    //         setLoading(false);
    //     }
    // };


 const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);

        if (selectedDishes.length === 0) {
            setMessage({ type: "error", text: "Select at least 1 dish ❌" });
            setLoading(false);
            return;
        }

        const payload = {
    userId: Number(userId),
    vendorId: Number(vendorId),
    customerId: `CUST_${Date.now()}`,

    fullName: form.fullName,
    email: form.email,
    phoneNumber: form.phoneNumber.replace(/^0+/, ''),

    event: "EVENT",
    eventType: form.eventType || "WEDDING",

    eventDate: formatDate(form.eventDate),
    fromDate: formatDate(form.eventDate),
    toDate: formatDate(form.eventDate),

    eventTime: "18:30",

    fullAddress: form.fullAddress,
    city: form.city,
    state: form.state,
    country: "India",

    companyName: "takebreak", // 👈 ADD THIS

    pincode: Number(form.pincode) || 0,
    vegPlates: Number(form.vegPlates) || 0,
    nonVegPlates: Number(form.nonVegPlates) || 0,
    mixedPlates: 0,

    budget: Number(form.budget) || 0,
    paymentAmount: 0,

    additionalRequests: form.specialRequests || '',
    leadStatus: "PENDING",

    items: {}, // 👈 VERY IMPORTANT (empty bhi chalega)

    dishId: selectedDishes,

    addOns: addOns
        .filter(a => a.selected && a.quantity > 0)
        .map(a => ({
            addOnType: a.type,
            quantity: a.quantity,
            selected: true // 👈 ADD THIS
        }))
};

        try {
            const res = await fetch(
    `https://backend.maamaas.com/catering/api/user/enquiry/create/?userId=${userId}`,
    {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${authToken}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    }
);
const text = await res.text();
// console.log("SERVER ERROR:", text);

            if (res.ok) {
                alert("Submitted Successfully ✅");
                setSelectedDishes([]);
                // setForm({
                //     fullName: '',
                //     email: '',
                //     phoneNumber: '',
                //     eventDate: '',
                //     eventType: '',
                //     guestCount: '',
                //     vegPlates: '',
                //     nonVegPlates: '',
                //     budget: '',
                //     specialRequests: '',
                //     fullAddress: '',
                //     city: '',
                //     state: '',
                //     pincode: ''
                // });
            } else {
                setMessage({ type: "error", text: "Submission failed ❌" });
            }
        } catch {
            setMessage({ type: "error", text: "Network error ❌" });
            
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="catering-customize-unique">
            <div className="form-container-unique-cater">
                {message && (
                    <div className={`alert-message-unique ${message.type}`}>
                        {message.text}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="catering-form-unique">
                    <div className="form-grid-unique">
                        {/* Personal Information */}
                        <div className="form-section-unique">
                            <div className="section-header-unique">
                                <span className="section-icon-unique">👤</span>
                                <h3>Contact Details</h3>
                            </div>
                            <div className="section-content-unique">
                                <div className="input-group-unique">
                                    <label>Full Name *</label>
                                    <input name="fullName" placeholder="Enter full name" value={form.fullName} onChange={handleChange} required />
                                </div>
                                <div className="input-group-unique">
                                    <label>Email *</label>
                                    <input type="email" name="email" placeholder="Enter email" value={form.email} onChange={handleChange} required />
                                </div>
                                <div className="input-group-unique">
                                    <label>Phone Number *</label>
                                    <input type="tel" name="phoneNumber" placeholder="Enter mobile number" value={form.phoneNumber} onChange={handleChange} required />
                                </div>
                            </div>
                        </div>

                        {/* Event Details */}
                        <div className="form-section-unique">
                            <div className="section-header-unique">
                                <span className="section-icon-unique">🎉</span>
                                <h3>Event Details</h3>
                            </div>
                            <div className="section-content-unique">
                                <div className="input-group-unique">
                                    <label>Event Date *</label>
                                    <input type="date" name="eventDate" value={form.eventDate} onChange={handleChange} required />
                                </div>
                                <div className="input-group-unique">
                                    <label>Event Type *</label>
                                    <select name="eventType" value={form.eventType} onChange={handleChange} required>
                                        <option value="">Select Event Type</option>
                                        <option value="WEDDING">Wedding</option>
                                        <option value="BIRTHDAY">Birthday</option>
                                        <option value="CORPORATE">Corporate</option>
                                        <option value="OTHER">Other</option>
                                    </select>
                                </div>
                                <div className="input-group-unique">
                                    <label>Number of Guests</label>
                                    <input type="number" name="guestCount" placeholder="Enter guest count" value={form.guestCount} onChange={handleChange} />
                                </div>
                            </div>
                        </div>

                        {/* Plate Details */}
                        <div className="form-section-unique">
                            <div className="section-header-unique">
                                <span className="section-icon-unique">🍽️</span>
                                <h3>Plates per Guest</h3>
                            </div>
                            <div className="section-content-unique row-2-unique">
                                <div className="input-group-unique">
                                    <label>Veg Plates</label>
                                    <input type="number" name="vegPlates" placeholder="Number of veg plates" value={form.vegPlates} onChange={handleChange} />
                                </div>
                                <div className="input-group-unique">
                                    <label>Non-Veg Plates</label>
                                    <input type="number" name="nonVegPlates" placeholder="Number of non-veg plates" value={form.nonVegPlates} onChange={handleChange} />
                                </div>
                            </div>
                        </div>

                        {/* Budget */}
                        <div className="form-section-unique">
                            <div className="section-header-unique">
                                <span className="section-icon-unique">💰</span>
                                <h3>Dining Budget Range</h3>
                            </div>
                            <div className="section-content-unique">
                                <div className="input-group-unique">
                                    <label>Expected Budget (₹)</label>
                                    <input type="number" name="budget" placeholder="Enter your budget" value={form.budget} onChange={handleChange} />
                                </div>
                            </div>
                        </div>

                        {/* Address Details */}
                        <div className="form-section-unique full-width-unique">
                            <div className="section-header-unique">
                                <span className="section-icon-unique">📍</span>
                                <h3>Address Details</h3>
                            </div>
                            <div className="section-content-unique">
                                <div className="input-group-unique full-width-unique">
                                    <label>Full Address</label>
                                    <input name="fullAddress" placeholder="Enter full address" value={form.fullAddress} onChange={handleChange} />
                                </div>
                                <div className="row-3-unique">
                                    <div className="input-group-unique">
                                        <label>City</label>
                                        <input name="city" placeholder="City" value={form.city} onChange={handleChange} />
                                    </div>
                                    <div className="input-group-unique">
                                        <label>State</label>
                                        <input name="state" placeholder="State" value={form.state} onChange={handleChange} />
                                    </div>
                                    <div className="input-group-unique">
                                        <label>Pincode</label>
                                        <input name="pincode" placeholder="Pincode" value={form.pincode} onChange={handleChange} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* DISH SELECTOR - DROPDOWN SIDEBAR + GRID SELECTED */}
                        <div className="form-section-unique full-width-unique">
                            <div className="section-header-unique">
                                <span className="section-icon-unique">🍛</span>
                                <h3>Select Dishes</h3>
                                <span className="selected-count-badge-unique">
                                    {selectedDishes.length} dishes selected
                                </span>
                            </div>
                            
                            <div className="dish-selector-grid-unique">
                                {/* LEFT: DROPDOWN SIDEBAR (ACCORDION) */}
                                <div className="dropdown-sidebar-unique">
                                    <div className="filter-bar-unique">
                                        <div className="veg-nonveg-filters-unique">
                                            <button
                                                type="button"
                                                className={`filter-chip-unique ${filter === 'ALL' ? 'active-filter-unique' : ''}`}
                                                onClick={() => setFilter('ALL')}
                                            >
                                                All
                                            </button>
                                            <button
                                                type="button"
                                                className={`filter-chip-unique ${filter === 'VEG' ? 'active-filter-unique' : ''}`}
                                                onClick={() => setFilter('VEG')}
                                            >
                                                <span className="veg-dot-unique"></span> Veg
                                            </button>
                                            <button
                                                type="button"
                                                className={`filter-chip-unique ${filter === 'NON-VEG' ? 'active-filter-unique' : ''}`}
                                                onClick={() => setFilter('NON-VEG')}
                                            >
                                                <span className="nonveg-dot-unique"></span> Non-Veg
                                            </button>
                                        </div>
                                    </div>

                                    {loadingDishes ? (
                                        <div className="loading-dishes-unique">
                                            <div className="spinner-unique"></div>
                                            <p>Loading delicious dishes...</p>
                                        </div>
                                    ) : (
                                        <div className="dropdown-categories-unique">
                                            {categories.map(category => {
                                                const categoryDishes = getDishesByCategory(category.dishId);
                                                const filteredDishes = filterDishesByType(categoryDishes);
                                                if (filteredDishes.length === 0) return null;
                                                
                                                return (
                                                    <div key={category.dishId} className="dropdown-item-unique">
                                                        <div 
                                                            className={`dropdown-header-unique ${openDropdowns[category.dishId] ? 'dropdown-open-unique' : ''}`}
                                                            onClick={() => toggleCategoryDropdown(category.dishId)}
                                                        >
                                                            <div className="dropdown-title-unique">
                                                                <span className="dropdown-icon-unique">📁</span>
                                                                <span className="dropdown-name-unique">{category.dishName}</span>
                                                                <span className="dropdown-badge-unique">{filteredDishes.length}</span>
                                                            </div>
                                                            <span className={`dropdown-arrow-unique ${openDropdowns[category.dishId] ? 'arrow-rotated-unique' : ''}`}>
                                                                ▼
                                                            </span>
                                                        </div>
                                                        
                                                        {openDropdowns[category.dishId] && (
                                                            <div className="dropdown-menu-unique">
                                                                {filteredDishes.map(dish => (
                                                                    <div
                                                                        key={dish.dishId}
                                                                        className={`dish-option-unique ${selectedDishes.includes(dish.dishId) ? 'dish-selected-unique' : ''}`}
                                                                        onClick={() => toggleDish(dish.dishId)}
                                                                    >
                                                                        <div className="dish-info-unique">
                                                                            <span className="dish-type-unique">
                                                                                {dish.dishType === 'VEG' ? '🟢' : '🔴'}
                                                                            </span>
                                                                            <span className="dish-name-unique">{dish.dishName}</span>
                                                                        </div>
                                                                        {selectedDishes.includes(dish.dishId) && (
                                                                            <span className="check-mark-unique">✓</span>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                            {categories.length === 0 && (
                                                <div className="no-dishes-unique">No categories available</div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* RIGHT: SELECTED DISHES - 3 ITEMS PER ROW GRID */}
                                <div className="selected-dishes-grid-unique">
                                    <div className="selected-header-unique">
                                        {/* <h3>Selected Dishes</h3>
                                        <div className="selected-count-unique">{selectedDishes.length} items</div> */}
                                        {/* {selectedDishes.length > 0 && (
                                            <button type="button" className="clear-all-unique" onClick={clearAllSelectedDishes}>
                                                Clear All
                                            </button>
                                        )} */}
                                    </div>
                                    <div className="selected-dishes-cards-unique">
                                        {getSelectedDishesDetails().length > 0 ? (
                                            getSelectedDishesDetails().map(dish => {
                                                const category = categories.find(c => c.dishId === dish.parentId);
                                                return (
                                                    <div key={dish.dishId} className="selected-card-unique">
                                                        <div className="card-content-unique">
                                                            <div className="card-dish-name-unique">
                                                                <span className="card-type-icon-unique">
                                                                    {dish.dishType === 'VEG' ? '🟢' : '🔴'}
                                                                </span>
                                                                <span>{dish.dishName}</span>
                                                            </div>
                                                            {category && (
                                                                <div className="card-category-unique">
                                                                    {category.dishName}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <button 
                                                            type="button"
                                                            className="remove-card-btn-unique"
                                                            onClick={() => removeSelectedDish(dish.dishId)}
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="empty-selected-unique">
                                                <div className="empty-icon-unique">🍽️</div>
                                                <p>No dishes selected</p>
                                                <p className="empty-hint-unique">Click on dishes from dropdown to add</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Add-ons */}
                        <div className="form-section-unique full-width-unique">
                            <div className="section-header-unique">
                                <span className="section-icon-unique">➕</span>
                                <h3>Add-ons</h3>
                            </div>
                            <div className="addons-list-unique">
                                {addOns.map((addon, i) => (
                                    <div key={i} className="addon-item-unique">
                                        <label className="addon-checkbox-unique">
                                            <input
                                                type="checkbox"
                                                checked={addon.selected}
                                                onChange={(e) => handleAddonChange(i, "selected", e.target.checked)}
                                            />
                                            <span className="checkbox-custom-unique"></span>
                                            <span className="addon-label-unique">{addon.type.replace('_', ' ')}</span>
                                        </label>
                                        {addon.selected && (
                                            <input
                                                type="number"
                                                className="addon-quantity-unique"
                                                placeholder="Qty"
                                                min="1"
                                                value={addon.quantity || ''}
                                                onChange={(e) => handleAddonChange(i, "quantity", e.target.value)}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Special Request */}
                        <div className="form-section-unique full-width-unique">
                            <div className="section-header-unique">
                                <span className="section-icon-unique">📝</span>
                                <h3>Special Requests</h3>
                            </div>
                            <div className="section-content-unique">
                                <textarea
                                    name="specialRequests"
                                    className="special-request-unique"
                                    placeholder="Any special requests or dietary requirements?"
                                    value={form.specialRequests}
                                    onChange={handleChange}
                                    rows="3"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-actions-unique">
                        <button type="submit" className="submit-button-unique" disabled={loading}>
                            {loading ? "Submitting..." : "Submit Enquiry"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CateringCustomize;
